import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Grid,
  Typography,
  TextareaAutosize,
  FormControl,
  InputAdornment,
  IconButton,
  DialogTitle,
  Dialog,
  DialogContent,
} from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ValidationError, number, object, string } from "yup";
import dayjs from "dayjs";
import styles from "../devoteeService.module.scss";
import constants from "../../../config/constants.json";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  CustomSelect,
  CustomMenuItem,
  StyledDateContainer,
  CustomDatePicker,
  CustomCalendarTodayOutlinedIcon,
  CustomInputLabel,
  CustomTextFeild,
  CustomDeleteIcon,
  CommonButton,
  CommonOutlinedButton,
  CustomBadge,
  CustomLeftIcon,
  CustomDeleteCircleIcon,
  CustomAddCircleIcon,
  CustomRequiredInputLabel,
  ContactNumberInput,
  CustomTextFeildPooja,
} from "../../common/StyledComponents/StyledFields";
import ModeofPayment from "../../common/modeOfPayment/modeOfPayment";
import {
  apiRequest,
  catchErrorMessageHandler,
  getDevoteeId,
} from "../../../infrastructure/backendService";
import {
  cartItemListProps,
  donationPurposeProps,
} from "../../../infrastructure/GlobalContextProvider";
import cartIcon from "../../../assets/svg/Cart.svg";
import ToastError from "../../common/toast/toastError";
import toast, { Toaster } from "react-hot-toast";
import apiPath from "../../../config/apiPaths.json";
import ToastSuccess from "../../common/toast/toastSuccess";
import LOCALE from "../../../config/en-us.json";
import CartItemsComponent from "../../common/cartItemsComponent/cartItems";
import { isBoolean, isNil } from "lodash";
import { ClipLoader } from "react-spinners";
import CloseIcon from "@mui/icons-material/Close";
import { Rowing } from "@mui/icons-material";
import { index } from "d3";
import { CustomNumberDonationField } from "../../devotee/donation/commonDonations";
import SuccessPopup from "../../devotee/donation/successPopup";
import Pagination from "../../common/pagination/pagination";
import ErrorPopup from "../../common/ErrorPopup";

interface ErrorMessageTypes {
  name: string;
  purposeOfDonation: string;
  noOfItem: string;
  ammountinDollars: string;
  disbursementReference: string;
  periodEnding: string;
  donorAdvisoryFunds_name: string;
  donorAdvisoryFunds_username: string;
  donorAdvisoryFunds_amount: string;
  description: string;
}

interface AdvisoryDonarProps {
  showHeaders?: boolean;
  username: string;
  onBackClick?: () => void;
}

interface ErrorMessageUserFormTypes {
  signinName: string;
  firstName: string;
  lastName: string;
  city: string;
  state: string;
  phonenumber: string;
  email: string;
  zipcode: string;
}

const DonorAdvisoryFunds = (props: AdvisoryDonarProps) => {
  const [membersList, setMembersList] = useState<Array<React.ReactElement>>([]);
  const [formData, setFormData] = useState({
    name: getDevoteeId()?.userId || "",
    purposeOfDonation: "",
    noOfItem: 0,
    ammountinDollars: 0,
    disbursementReference: "",
    periodEnding: "",
    description: "",
  });

  const [userFormData, setuserFormData] = useState({
    signinName: "",
    firstName: "",
    lastName: "",
    phonenumber: "",
    email: "",
    city: "",
    state: "",
    zipcode: "",
  });
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [errorMessageUserForm, setErrorMessageUserForm] =
    useState<ErrorMessageUserFormTypes>({
      signinName: "",
      firstName: "",
      lastName: "",
      phonenumber: "",
      email: "",
      city: "",
      state: "",
      zipcode: "",
    });
  const [addmorefields, setAddmorefields] = useState([
    {
      donorAdvisoryFunds_name: "",
      donorAdvisoryFunds_username: "",
      donorAdvisoryFunds_amount: "",
    },
  ]);

  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    name: "",
    purposeOfDonation: "",
    noOfItem: "",
    ammountinDollars: "",
    disbursementReference: "",
    periodEnding: "",
    donorAdvisoryFunds_name: "",
    donorAdvisoryFunds_username: "",
    donorAdvisoryFunds_amount: "",
    description: "",
  });
  const [donationPurposeItems, setDonationPurposeItems] = useState<
    donationPurposeProps[]
  >([]);
  const [totalDonationAmount, setTotalDonationAmount] = useState<number>(0);
  const [cartItemsList, setcartItemsList] = useState<cartItemListProps[]>([]);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [showList, setShowList] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [isAnadanna, setIsAnadanna] = useState<boolean>(false);
  const [isVastra, setIsVastra] = useState<boolean>(false);
  const [annadanaCount, setAnnadanaCount] = useState<number>(1);
  const [usernameError, setUsernameError] = useState("");
  const [nameError, setNameError] = useState("");
  const [serivesText, setServiceText] = useState<string[]>(
    Array.from({ length: annadanaCount }, () => "")
  );
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(
    Array.from({ length: annadanaCount }, () => false)
  );
  const [serviceDates, setServiceDates] = useState<string[]>(
    Array.from({ length: annadanaCount }, () => "")
  );
  const [searchItems, setSearchItem] = useState([]);
  const [searchButton, setSearchButton] = useState<boolean>(true);
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [usersList, setUsersList] = useState<any[]>([]);
  const [selectedItem, setSelectedItem] = useState("");
  const [list, setList] = useState("");
  const [vastraCount, setVastraCount] = useState<number>(1);
  const [addFieldsCount, setAddFieldsCount] = useState<number>(1);
  const [isAddMoreFields, setIsAddMoreFields] = useState<boolean>(true);
  const [serivesVastraText, setServicevastraText] = useState<string[]>(
    Array.from({ length: vastraCount }, () => "")
  );
  // const [isDatePickerOpen, setIsDatePickerOpen] = useState(
  //    Array.from({ length: vastraCount }, () => false)
  // );
  const [serviceVastraDates, setServiceVastraDates] = useState<string[]>(
    Array.from({ length: vastraCount }, () => "")
  );

  const [textFields, setTextFields] = useState<string[]>(
    Array.from({ length: addFieldsCount }, () => "")
  );

  const [usernameText, setUsernameText] = useState<string[]>(
    Array.from({ length: addFieldsCount }, () => "")
  );
  const [nameText, setNameText] = useState<string[]>(
    Array.from({ length: addFieldsCount }, () => "")
  );
  // const [textError, setTextError] = useState('');
  const [amountField, setAmountField] = useState<number[]>(
    Array.from({ length: addFieldsCount })
  );
  const [newText, setNewText] = useState<string[]>(
    Array.from({ length: addFieldsCount }, () => "")
  );

  const [showDropDown, setShowDropDown] = useState<boolean>(false);
  const [isDatePickerOpenPE, setDatePickerOpenPE] = useState(false);

  const handleDatePickerClickForPeriodEnding = () => {
    setDatePickerOpenPE(true);
  };

  useEffect(() => {
    setDatePickerOpenPE(false);
  }, [formData.periodEnding]);


  const [rowIndex, setRowIndex] = useState(0);
  const validationSchema = object().shape({
    // name: string().required('Name is required'),
    purposeOfDonation: string().required(
      "Please select the purpose of donation"
    ),
    noOfItem: string().required("No. of item is required"),
    ammountinDollars: number().required("Amount in Dollars is required").min(1, "Minimum amount is 1")
    .transform((value, originalValue) => {
      return originalValue === "" ? undefined : value;
    }),
    disbursementReference: string().required(
      "Disbursement Reference is required"
    ),
    periodEnding: string().required("Period Ending is required"),
    // donorAdvisoryFunds_name: string().required('Donor Advisory Funds(name) is required'),
    // donorAdvisoryFunds_username: string().required('Donor Advisory Funds(username) is required'),
    // donorAdvisoryFunds_amount: string().required('Donor Advisory Funds(amount) is required'),
    description: string().required("Description is required"),
  });

  const validationSchemaUserForm = object().shape({
    // usernameText: string().required('Username is required'),
    // nameText: string().required('Name is required'),
    // amountField: string().required('Amount is required'),
  });

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.purposeOfDonations,
      // includeToken: true,
    })
      .then((res) => {
        setDonationPurposeItems(res.data);
      })
      .catch((err) => {
        console.log(err, "donationerrorrrrr");
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  }, []);

  useEffect(() => {
    getCartItems();
  }, []);

  const getCartItems = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.cartItems,
      includeToken: true,
      params: {
        username: props.username,
      },
    })
      .then((res) => {
        setShowList(false);
        setcartItemsList(res.data.bookedItemInCart);
        setTotalDonationAmount(res.data.totalAmount);
      })
      .catch((err) => {
        console.log(err);
        setShowList(false);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const handleAdd = async () => {
    const errors: ErrorMessageTypes = {
      name: "",
      purposeOfDonation: "",
      noOfItem: "",
      ammountinDollars: "",
      disbursementReference: "",
      periodEnding: "",
      description: "",
      donorAdvisoryFunds_name: "",
      donorAdvisoryFunds_username: "",
      donorAdvisoryFunds_amount: "",
    };
    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);

      // Call your API or perform other actions here
      addToCartApiCall();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
    // Check if usernameText is empty
    // if (usernameText.length === 0 || !usernameText[0].trim()) {
    //   setTextError('Username is Required');
    // } 
    // else  {
    //   setTextError("");
    //   // Add functionality here for what happens when "Add" button is clicked
    // }

  };

  const addToCartApiCall = () => {
    if (nameText.every(text => text.trim() === "")) {
      setNameError("Name is required.");
      usernameText.every(text => text.trim() === "") &&  setUsernameError("Username is required.");
      return;
  } else {
      setNameError(""); // Update the state variable here when validation passes
  }

    const reqBody = {
      onBehalfOfUsername: getDevoteeId()?.userId?.toUpperCase(),
      donationsPurposeId: formData.purposeOfDonation,
      numberOfItems: parseFloat(formData.noOfItem.toString()),
      amount: parseFloat(formData.ammountinDollars.toString()),
      disbReference: formData.disbursementReference,
      periodEnding: formData.periodEnding,
      description: formData.description,
      donationType: "MATCHING_DONATION",
      dateOfDonation: "",
      serviceDates: serviceDates,
      displayMessages: serivesText,
      annadana: isAnadanna,
      vastra: isVastra,
      vastraCodes: serivesVastraText,
      matchingDonationNames: nameText,
      matchingDonationUsernames: usernameText,
      matchingDonationAmounts: amountField,
    };
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: apiPath.matchingAndAdvisoryDonarApi,
      includeToken: true,
      body: JSON.stringify(reqBody),
    })
      .then((res) => {
        setLoading(false);
        setFormData({
          name: "",
          purposeOfDonation: "",
          noOfItem: 0,
          ammountinDollars: 0,
          disbursementReference: "",
          periodEnding: "",
          description: "",
        });
        setAmountField([0]);
        setUsernameText([""]);
        setNameText([""]);
        setServiceDates([""]);
        setServiceText([""]);
        setServicevastraText([""]);
        getCartItems();
        setNameError("");
        setUsernameError("");
       
        // toast.custom(<ToastSuccess message={LOCALE.ITEM_ADDED} />);
        toast.custom(
          <SuccessPopup
            headerMessage="Items Added"
            showMessage={LOCALE.ITEM_ADDED}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      })
      .catch((err) => {
        setLoading(false);
        setAmountField([0]);
        setUsernameText([""]);
        setNameText([""]);
        setServiceDates([""]);
        setServiceText([""]);
        setServicevastraText([""]);
        setNameError("");
        setUsernameError("");
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const handleOpenDialog = (item: string) => {
    setOpenCancelDialog(true);
  };

  const handleCancelDialogClose = () => {
    setOpenCancelDialog(false);
  };

  const handleSelect = (): any => {
    // Handle select logic here, if needed
    setList(selectedItem);
    const newTextValues = [...usernameText];
    newTextValues[rowIndex] = selectedItem;
    setUsernameText(newTextValues);
    // addmorefields[index].donorAdvisoryFunds_username = selectedItem;
    setOpenCancelDialog(false);
    setShowDropDown(false);
    setSelectedItem("");
  };

  const handleSearch = async (): Promise<void> => {
    const errors: ErrorMessageUserFormTypes = {
      signinName: "",
      firstName: "",
      lastName: "",
      phonenumber: "",
      email: "",
      city: "",
      state: "",
      zipcode: "",
    };
    try {
      // Validate the form data against the validation schema
      await validationSchemaUserForm.validate(userFormData, {
        abortEarly: false,
      });
      // If validation passes, you can submit the form
      setErrorMessageUserForm(errors);

      // Call your API or perform other actions here
      searchDataApi();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageUserFormTypes] = e.message;
          }
        });
      }
      setErrorMessageUserForm(errors);
    }
  };

  const searchDataApi = () => {
    const reqBody = {
      firstname: userFormData.firstName,
      lastname: userFormData.lastName,
      email: userFormData.email,
      username: userFormData.signinName,
      city: userFormData.city,
      state: userFormData.state,
      zipcode: userFormData.zipcode,
      sortBy: userFormData.signinName,
      phoneNumber: userFormData.phonenumber,
      matchOperator: "AND",
    };
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: apiPath.serachDevoteeApi,
      body: JSON.stringify(reqBody),
      includeToken: true,
      params: {
        sortBy: userFormData.signinName,
        //  page: pageNumber - 1,
        size: 20,
        direction: "asc",
      },
    })
      .then((res) => {
        setLoading(false);
        setUsersList(res.data.content);
        setShowDropDown(true);
        //  setTotalRecords(res.data.totalElements);
        if (res.data.length === 0) {
          setErrorMessageUserForm({
            ...errorMessageUserForm,
            signinName: "No Records found",
          });
        } else {
          setSearchItem(res.data.content);
          setErrorMessageUserForm({ ...errorMessageUserForm, signinName: "" });
        }
      })
      .catch((err) => {
        console.log(err, "searchItems............");
        setLoading(false);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const zipCodeApi = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.cityAndStateApi,
      params: {
        zip: userFormData.zipcode,
      },
    })
      .then((res) => {
        setErrorMessageUserForm({
          ...errorMessageUserForm,
          zipcode: "",
        });
        setuserFormData({
          ...userFormData,
          state: res.data.stateName,
          city: res.data.city,
        });
      })
      .catch((err) => {
        console.log(err);

        setErrorMessageUserForm({
          ...errorMessageUserForm,
          zipcode: catchErrorMessageHandler(err),
        });
        setuserFormData({
          ...userFormData,
          state: "",
          city: "",
        });
      });
  };

  const handleSearchDevoteeFieldChange = (field: string, value: any) => {
    if (
      userFormData.signinName ||
      userFormData.firstName ||
      userFormData.lastName
    ) {
      setSearchButton(false);
    } else {
      setSearchButton(true);
    }
    setuserFormData({
      ...userFormData,
      [field]: value,
    });
  };

  const handleDateChange = (field: any, value: any) => {
    const formattedDate = dayjs(value, "MM-DD-YYYY");
    // setCurrentItem((prevItem) => ({ ...prevItem, [field]: formattedDate.isValid() ? formattedDate.format('MM-DD-YYYY') : '' }));
    setFormData({
      ...formData,
      [field]: formattedDate.isValid()
        ? formattedDate.format("MM-DD-YYYY")
        : "",
    });
  };

  const handleFieldChange = (field: string, value: any) => {
    if (field === "purposeOfDonation") {
      const selectedDonation: any = donationPurposeItems.find(
        (donation: donationPurposeProps) => donation.accountNumber === value
      );
      setFormData({
        ...formData,
        [field]: value,
      });
      if (!isNil(selectedDonation)) {
        const donationName = selectedDonation?.accountDescription;
        if (donationName === "ANNADAANA") {
          setIsAnadanna(true);
          setIsVastra(false);
        } else if (donationName === "VASTRA") {
          setIsVastra(true);
          setIsAnadanna(false);
        } else {
          setServiceText([]);
          setServiceDates([]);
          setIsAnadanna(false);
          setIsVastra(false);
        }
      }
    } else {
      setFormData({
        ...formData,
        [field]: value,
      });
    }
  };

  const PurposeDonationDropdown = (): React.ReactElement => {
    return (
      <FormControl className={styles.dropDowns}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          defaultValue=""
          id="purposeOfDonation"
          placeholder="Select pooja Type"
          value={formData.purposeOfDonation}
          onChange={(e) => {
            handleFieldChange("purposeOfDonation", e.target.value);
            setErrorMessage({ ...errorMessage, purposeOfDonation: "" });
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          className={
            errorMessage.purposeOfDonation
              ? styles.errorTextField
              : styles.textField
          }
        >
          {donationPurposeItems.map(
            (item: donationPurposeProps, index: number) => (
              <CustomMenuItem key={index} value={item.accountNumber}>
                {item.accountDescription}
              </CustomMenuItem>
            )
          )}
        </CustomSelect>
        {errorMessage.purposeOfDonation ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.purposeOfDonation}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    );
  };
  const handleDatePickerClick = (index: number) => {
    const newIsDatePickerOpen = [...isDatePickerOpen];
    newIsDatePickerOpen[index] = true;
    setIsDatePickerOpen(newIsDatePickerOpen);
  };

  const handleCloseDatePicker = (index: number) => {
    const newIsDatePickerOpen = [...isDatePickerOpen];
    newIsDatePickerOpen[index] = false;
    setIsDatePickerOpen(newIsDatePickerOpen);
  };

  const handleDatePickerChange = (index: number, date: any) => {
    const formattedDate = dayjs(date, "MM-DD-YYYY");
    const newServiceDates = [...serviceDates];
    newServiceDates[index] = formattedDate.isValid()
      ? formattedDate.format("MM-DD-YYYY")
      : "";

    setServiceDates(newServiceDates);
  };


  useEffect(() => {
    handleCloseDatePicker(serviceDates.length - 1);
}, [serviceDates]);


  const handleAddAnnadana = (index: number) => {
    setAnnadanaCount((prevCount) => prevCount + 1);
  };

  const handleDeleteAnnadana = (index: number) => {
    if (annadanaCount > 1) {
      setAnnadanaCount((prevCount) => prevCount - 1);
      const newServiceDates = [...serviceDates];
      const newMessages = [...serivesText];
      newServiceDates.splice(index, 1);
      newMessages.splice(index, 1);
      setServiceDates(newServiceDates);
      setServiceText(newMessages);
    }
  };

  const handleAddMoreFields = () => {
    setAddFieldsCount((prevCount) => prevCount + 1);
  };

  const handleDeleteMoreFields = (index: any) => {
    if (addFieldsCount > 1) {
      setAddFieldsCount((prevCount) => prevCount - 1);
      const newUserNameTextFields = [...usernameText];
      const newNameText = [...nameText];
      const newAmount = [...amountField];
      newUserNameTextFields.splice(index, 1);
      newNameText.splice(index, 1);
      newAmount.splice(index, 1);
      setUsernameText(newUserNameTextFields);
      setNameText(newNameText);
      setAmountField(newAmount);
    }
  };

  const handleAddVastra = (index: number) => {
    setVastraCount((prevCount) => prevCount + 1);
  };

  const handleDeleteVastra = (index: number) => {
    if (vastraCount > 1) {
      setVastraCount((prevCount) => prevCount - 1);
      const newServiceDates = [...serviceDates];
      const newMessages = [...serivesText];
      newServiceDates.splice(index, 1);
      newMessages.splice(index, 1);
      setServiceDates(newServiceDates);
      setServiceText(newMessages);
    }
  };

  const handleSearchDevotee = (index: any) => {
    setRowIndex(index);
    setOpenCancelDialog(true);
  };

  const BasicDatePicker1 = (index: number): React.ReactElement => {
    return (
      <div style={{ minWidth: "100%", borderRadius: "8px" }}>
        <StyledDateContainer
          sx={{
            backgroundColor: "#FFF9E4",
            borderRadius: "8px",
            height: "48px",
          }}
          onClick={() => handleDatePickerClick(index)}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                open={isDatePickerOpen[index]}
                onClose={() => handleCloseDatePicker(index)}
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  serviceDates[index]
                    ? dayjs(serviceDates[index], "MM-DD-YYYY")
                    : ""
                }
                disablePast
                onChange={(date) => handleDatePickerChange(index, date)}
                className={styles.dateFeild}
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </div>
    );
  };

  const serviceTextComponent = (index: number) => {
    return (
      <>
        <CustomInputLabel>Message to Be Displayed on TV</CustomInputLabel>
        <CustomTextFeild
          fullWidth
          required
          className={styles.textField}
          value={serivesText[index]}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const newTextValues = [...serivesText];
            newTextValues[index] = e.target.value;
            setServiceText(newTextValues);
          }}
          placeholder="Enter Message"
        />
      </>
    );
  };

  const donarUserNameComponent = (index: number) => {
    const handleChange = (newText: string) => {
      const newTextValues = [...usernameText];
      newTextValues[index] = newText;
      setUsernameText(newTextValues);
    };

    return (
      <>
        {CustomRequiredInputLabel("Username", true)}
        <CustomTextFeild
          fullWidth
          required
          className={styles.textField}
          value={usernameText[index]}
          placeholder="Enter Message"
          InputProps={{
            readOnly: true,
          }}
        // onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
        //   handleChange(e.target.value)
        // }
        />
        {/* {textError && <span style={{ color: 'red' }}>{textError}</span>} */}
        {usernameError && !usernameText?.[index] && <span style={{ color: 'red' }}>{usernameError}</span>}
      </>
    );
  };

  const donarNameComponent = (index: number) => {
    const handleChange = (newText: string) => {
      const newTextValues = [...nameText];
      newTextValues[index] = newText;
      setNameText(newTextValues);
    };

    return (
      <>
        {CustomRequiredInputLabel("Name", true)}
        <CustomTextFeild
          fullWidth
          required
          value={nameText[index]}
          className={styles.textField}
          placeholder="Enter Message"
          InputProps={{
            readOnly: true,
          }}
          // onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          //   handleChange(e.target.value)
          // }
        />
        {nameError && !nameText?.[index]  && <span style={{ color: 'red' }}>{nameError}</span>}
      </>
    );
  };

  const donatAmounttComponent = (index: number) => {
    return (
      <>
        {CustomRequiredInputLabel("Amount", true)}
        <CustomTextFeild
          fullWidth
          required
          type="number"
          className={styles.textField}
          value={amountField[index]}
          onChange={(e) => {
            const input = e.target.value;
            const numericValue = input.replace(/[^0-9.]/g, "");
            const newTextValues = [...amountField];
            // if (numericValue !== "" && !isNaN(parseFloat(numericValue))) {
            //   newTextValues[index] = parseFloat(numericValue);
            // } else {
            //   newTextValues[index] = 0;
            // }
            newTextValues[index] = parseFloat(numericValue);
            setAmountField(newTextValues);
          }}
          placeholder="Enter Message"
        />
      </>
    );
  };

  const buttonsSearchDevoteeComponent = (index: any) => {
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          gap: "20px",
        }}
      >
        <div style={{ marginTop: "25px" }}>
          <CommonOutlinedButton
            sx={{ width: "maxContent" }}
            onClick={() => handleSearchDevotee(index)}
          >
            Search Devotee
          </CommonOutlinedButton>
        </div>
        {addFieldsCount === 1 ? (
          ""
        ) : (
          <div style={{ marginTop: "-10px" }}>
            <Card className={styles.CardwithDeleteIconStyles}>
              <div
                style={{ position: "absolute", right: "13px", top: "6px" }}
                onClick={() => handleDeleteMoreFields(index)}
              >
                <CustomDeleteIcon />
              </div>
            </Card>
          </div>
        )}
      </div>
    );
  };

  const addMoreFieldsComponent = (index: number) => {
    return (
      <Grid
        container
        spacing={2}
        sx={{ display: "flex", flexDirection: "row" }}
      >
        <Grid xs={12} sm={3} item>
          {donarUserNameComponent(index)}
        </Grid>
        <Grid xs={12} sm={3} item>
          {donarNameComponent(index)}
        </Grid>
        <Grid xs={12} sm={3} item>
          {donatAmounttComponent(index)}
        </Grid>
        <Grid xs={12} sm={3} item>
          {buttonsSearchDevoteeComponent(index)}
        </Grid>
      </Grid>
    );
  };

  const buttonsComponent = (index: number) => {
    return (
      <div style={{marginTop:"25px"}}>
        <IconButton
          sx={{ marginTop: "auto", marginBottom: "auto" }}
          onClick={() => handleAddAnnadana(index)}
        >
          <CustomAddCircleIcon />
        </IconButton>
        {annadanaCount === 1 ? (
          ""
        ) : (
          <IconButton
            sx={{ marginTop: "auto", marginBottom: "auto" }}
            disabled={annadanaCount === 1}
            onClick={() => handleDeleteAnnadana(index)}
          >
            <CustomDeleteCircleIcon />
          </IconButton>
        )}
      </div>
    );
  };

  const annadannaComponent = (index: number) => {
    return (
      <Grid container spacing={2}>
        <Grid xs={12} sm={3} item>
          {CustomRequiredInputLabel("Service Date", false)}
          {BasicDatePicker1(index)}
        </Grid>
        <Grid xs={12} sm={3} item>
          {serviceTextComponent(index)}
        </Grid>
        <Grid xs={12} sm={3} item>
          {buttonsComponent(index)}
        </Grid>
      </Grid>
    );
  };

  const serviceDatePicker = (index: number): React.ReactElement => {
    return (
      <div style={{ minWidth: "100%", borderRadius: "8px" }}>
        <StyledDateContainer
          sx={{
            backgroundColor: "#FFF9E4",
            borderRadius: "8px",
            height: "48px",
          }}
          onClick={() => handleDatePickerClick(index)}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                open={isDatePickerOpen[index]}
                onClose={() => handleCloseDatePicker(index)}
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  serviceDates[index]
                    ? dayjs(serviceDates[index], "MM-DD-YYYY")
                    : ""
                }
                disablePast
                onChange={(date) => handleDatePickerChange(index, date)}
                className={styles.dateFeild}
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </div>
    );
  };

  const vastraCodeTextComponent = (index: number) => {
    return (
      <>
        <CustomInputLabel>Vastra Code</CustomInputLabel>
        <CustomTextFeild
          fullWidth
          required
          className={styles.textField}
          value={serivesVastraText[index]}
          onChange={(e) => {
            const newTextValues = [...serivesVastraText];
            newTextValues[index] = e.target.value;
            setServicevastraText(newTextValues);
          }}
          placeholder="Enter Message"
        />
      </>
    );
  };

  const buttonsVastraComponent = (index: number) => {
    return (
      <div>
        <IconButton
          sx={{ marginTop: "auto", marginBottom: "auto" }}
          onClick={() => handleAddVastra(index)}
        >
          <CustomAddCircleIcon />
        </IconButton>
        {vastraCount === 1 ? (
          ""
        ) : (
          <IconButton
            sx={{ marginTop: "auto", marginBottom: "auto" }}
            disabled={vastraCount === 1}
            onClick={() => handleDeleteVastra(index)}
          >
            <CustomDeleteCircleIcon />
          </IconButton>
        )}
      </div>
    );
  };

  const vastraComponent = (index: number) => {
    return (
      <Grid container spacing={2}>
        <Grid xs={12} sm={3} item>
          {CustomRequiredInputLabel("Service Date", false)}
          {serviceDatePicker(index)}
        </Grid>
        <Grid xs={12} sm={3} item>
          {vastraCodeTextComponent(index)}
        </Grid>
        <Grid xs={12} sm={3} item>
          {buttonsVastraComponent(index)}
        </Grid>
      </Grid>
    );
  };

  const BasicDatePicker = (): React.ReactElement => {
    return (
      <div style={{ minWidth: "100%" }}>
        <StyledDateContainer id="periodEnding" onClick={handleDatePickerClickForPeriodEnding}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
               open={isDatePickerOpenPE}
               onClose={() => setDatePickerOpenPE(false)}
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                // format="DD-MM-YYYY"
                value={
                  formData.periodEnding
                    ? dayjs(formData.periodEnding, "MM-DD-YYYY")
                    : ""
                }
                disablePast
                onChange={(value) => {
                  handleDateChange("periodEnding", value);
                  setErrorMessage({ ...errorMessage, periodEnding: "" });
                }}
                className={
                  errorMessage.periodEnding
                    ? styles.errorTextField
                    : styles.textField
                }
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorMessage.periodEnding ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.periodEnding}
            </Typography>
          ) : (
            ""
          )}
        </StyledDateContainer>
      </div>
    );
  };

  const handleAddmorefieldsChange = (
    index: number,
    field: string,
    value: any,
    rowIndex: any
  ) => {
    setAddmorefields((prevFields) => {
      const newFields = [...prevFields];
      newFields[index] = {
        ...newFields[index],
        [field]: index === rowIndex ? value : "",
      };
      return newFields;
    });
  };

  const handleCart = (): void => {
    if (cartItemsList.length > 0) {
      setShowList(true);
    } else {
      setShowList(false);
    }
  };

  const navigateBack = () => {
    getCartItems()
  };

  const cartComponent = () => {
    return (
      <div style={{ width: "100%" }}>
        <div className={styles.backArrow} style={{margin: "0px"}}>
          <div onClick={navigateBack} style={{ marginRight: "10px", display: "flex", alignItems: "center" }}>
            <CustomLeftIcon />
          </div>
          <Typography className={styles.heading}>List of Item Added</Typography>
        </div>
        <CartItemsComponent navigateBack={navigateBack}/>
      </div>
    );
  };

  const annadanaComponents = Array.from(
    { length: annadanaCount },
    (_, index) => (
      <div key={index} style={{ marginTop: "12px" }}>
        {annadannaComponent(index)}
      </div>
    )
  );

  const vastraComponents = Array.from({ length: vastraCount }, (_, index) => (
    <div key={index} style={{ marginTop: "12px" }}>
      {vastraComponent(index)}
    </div>
  ));

  const membersComponents = Array.from(
    { length: addFieldsCount },
    (_, index) => (
      <div key={index} style={{ marginTop: "12px" }}>
        {/* <Typography className={styles.typoGraphy} sx={{marginBottom: "10px"}}>Matching Donations</Typography> */}
        {addMoreFieldsComponent(index)}
      </div>
    )
  );

  const handleDropdownChange = (e: any) => {
    setSelectedItem(e.target.value);
    const selectedUser = usersList.find(
      (item) => item.username === e.target.value
    );
    if (selectedUser) {
      const newTextValues = [...nameText];
      const fname = isNil(selectedUser.firstname) ? "" : selectedUser.firstname;
      const Lname = isNil(selectedUser.lastname) ? "" : selectedUser.lastname;
      const mName = isNil(selectedUser.middleName)
        ? ""
        : selectedUser.middleName;
      newTextValues[rowIndex] = fname + " " + mName + " " + Lname;
      setNameText(newTextValues);
    }
  };

  const searchedDropdownList = (): React.ReactElement => {
    return (
      <FormControl className={styles.dropDowns} sx={{ width: "200px" }}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          defaultValue=""
          id="grouped-select"
          placeholder="Select pooja Type"
          value={selectedItem}
          onChange={handleDropdownChange}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          className={styles.textField}
        >
          {usersList.map((item: any, index: number) => (
            <CustomMenuItem key={index} value={item.username}>
              {item.firstname}_{item.lastName}_{item.lastname} ({item.username})
            </CustomMenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    );
  };

  const handleSignInNameClick = (selectedItem: string) => {
    setList(selectedItem);
    const newTextValues = [...usernameText];
    newTextValues[rowIndex] = selectedItem;
    setUsernameText(newTextValues);
    setOpenCancelDialog(false);
    setShowDropDown(false);
    setSelectedItem("");
    const selectedUser = usersList.find(
      (item) => item.username === selectedItem
    );
    if (selectedUser) {
      const fname = isNil(selectedUser.firstname) ? "" : selectedUser.firstname;
      const Lname = isNil(selectedUser.lastname) ? "" : selectedUser.lastname;
      const mName = isNil(selectedUser.middleName)
        ? ""
        : selectedUser.middleName;
      const newTextValues = [...nameText];
      newTextValues[rowIndex] = fname + " " + mName + " " + Lname;
      setNameText(newTextValues);
    }
  };

  const listItemTable = () => {
    return (
      <>
        <div style={{ overflowY: "auto" }}>
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                <th className={styles.tableHorizontal}>Sign-In Name</th>
                <th className={styles.tableHorizontal}>Name</th>
                <th className={styles.tableHorizontal}>Address</th>
                <th className={styles.tableHorizontal}>Email</th>
                <th className={styles.tableHorizontal}>PhoneNo</th>
              </tr>
            </thead>
            <tbody className={styles.tableBody} id="searchTable">
              {searchItems.map((row: any, id: number) => (
                <tr key={id} className={styles.tableRow}>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "center",
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                    onClick={() => handleSignInNameClick(row.username)}
                  >
                    {row.username}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "center",
                    }}
                  >
                    {`${row.firstname} ${row.lastname}`}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      color: "#000",
                      fontWeight: 400,
                      textAlign: "center",
                    }}
                  >
                    {row.address}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "center",
                    }}
                  >
                    {row.email}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 400,
                      color: "#000",
                      textAlign: "center",
                    }}
                  >
                    {row.phoneWork}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {totalRecords > 5 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginRight: "10px",
              marginTop: "3px",
            }}
          >
            <Pagination
              items={totalRecords}
              itemsPerPage={5}
              setPageNumber={setPageNumber}
              pageNumber={pageNumber}
            />
          </div>
        ) : (
          ""
        )}
      </>
    );
  };

  const SearchDevotee = () => {
    return (
      <div className={styles.SearchContainer}>
        <form className={styles.formContainer} autoComplete="off">
          <Grid container spacing={2}>
            <Grid xs={12} sm={4} item >
              {CustomRequiredInputLabel("Sign-In Name", false)}
              <CustomTextFeildPooja
                id="signInName"
                fullWidth
                required
                onChange={(e) => {
                  handleSearchDevoteeFieldChange("signinName", e.target.value);
                  setErrorMessageUserForm({
                    ...errorMessageUserForm,
                    signinName: "",
                  });
                }}
                className={
                  errorMessageUserForm.signinName
                    ? styles.errorTextField
                    : styles.textField
                }
              />
              {errorMessageUserForm.signinName ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessageUserForm.signinName}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
            <Grid xs={12} sm={4} item >
              {CustomRequiredInputLabel("First Name", false)}
              <CustomTextFeildPooja
              id="firstName"
                fullWidth
                required
                onChange={(e) => {
                  handleSearchDevoteeFieldChange("firstName", e.target.value);
                  setErrorMessageUserForm({
                    ...errorMessageUserForm,
                    firstName: "",
                  });
                }}
                className={
                  errorMessageUserForm.firstName
                    ? styles.errorTextField
                    : styles.textField
                }
              />
              {errorMessageUserForm.firstName ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessageUserForm.firstName}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
            <Grid xs={12} sm={4} item >
              {CustomRequiredInputLabel("Last Name", false)}
              <CustomTextFeildPooja
              id="lastName"
                fullWidth
                required
                onChange={(e) => {
                  handleSearchDevoteeFieldChange("lastName", e.target.value);
                  setErrorMessageUserForm({
                    ...errorMessageUserForm,
                    lastName: "",
                  });
                }}
                className={
                  errorMessageUserForm.lastName
                    ? styles.errorTextField
                    : styles.textField
                }
              />
              {errorMessageUserForm.lastName ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessageUserForm.lastName}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: "0px" }}>
            <Grid xs={12} sm={4} item >
              {CustomRequiredInputLabel("Zip Code", false)}
              <CustomTextFeildPooja
              id="zipCode"
                fullWidth
                required
                onChange={(e) => {
                  handleSearchDevoteeFieldChange("zipcode", e.target.value);
                  setErrorMessageUserForm({
                    ...errorMessageUserForm,
                    zipcode: "",
                  });
                }}
                onBlur={zipCodeApi}
                className={
                  errorMessageUserForm.zipcode
                    ? styles.errorTextField
                    : styles.textField
                }
              />
              {errorMessageUserForm.zipcode ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessageUserForm.zipcode}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
            <Grid xs={12} sm={4} item >
              {CustomRequiredInputLabel("City", false)}
              <CustomTextFeildPooja
              id="city"
                fullWidth
                required
                onChange={(e) => {
                  handleSearchDevoteeFieldChange("city", e.target.value);
                  setErrorMessageUserForm({
                    ...errorMessageUserForm,
                    city: "",
                  });
                }}
                value={userFormData.city}
                InputProps={{
                  readOnly: true,
                }}
                className={
                  errorMessageUserForm.city
                    ? styles.errorTextField
                    : styles.textField
                }
              />
              {errorMessageUserForm.city ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessageUserForm.city}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
            <Grid xs={12} sm={4} item >
              {CustomRequiredInputLabel("State", false)}
              <CustomTextFeildPooja
              id="state"
                fullWidth
                required
                onChange={(e) => {
                  handleSearchDevoteeFieldChange("state", e.target.value);
                  setErrorMessageUserForm({
                    ...errorMessageUserForm,
                    state: "",
                  });
                }}
                value={userFormData.state}
                InputProps={{
                  readOnly: true,
                }}
                className={
                  errorMessageUserForm.state
                    ? styles.errorTextField
                    : styles.textField
                }
              />
              {errorMessageUserForm.state ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessageUserForm.state}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: "0px" }}>
            <Grid xs={12} sm={4} item >
              {CustomRequiredInputLabel("Phone Number", false)}
              <CustomTextFeildPooja
              id="phoneNumber"
               fullWidth
               value={userFormData.phonenumber}
                onChange={(e) => {
                  const inputNumber = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                  const slicedNumber = inputNumber.slice(0, 10); // Limit to 10 digits
                  handleSearchDevoteeFieldChange("phonenumber",slicedNumber);
                  setErrorMessageUserForm({
                    ...errorMessageUserForm,
                    phonenumber: "",
                  });
                }}
                className={
                  errorMessageUserForm.phonenumber
                    ? styles.errorTextField
                    : styles.textField
                }
              />
              {errorMessageUserForm.phonenumber ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessageUserForm.phonenumber}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
            <Grid xs={12} sm={4} item >
              {CustomRequiredInputLabel("Email ID", false)}
              <CustomTextFeildPooja
              id="email"
                fullWidth
                required
                onChange={(e) => {
                  handleSearchDevoteeFieldChange("email", e.target.value);
                  setErrorMessageUserForm({
                    ...errorMessageUserForm,
                    email: "",
                  });
                }}
                className={
                  errorMessageUserForm.email
                    ? styles.errorTextField
                    : styles.textField
                }
              />
              {errorMessageUserForm.email ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessageUserForm.email}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
          </Grid>
          {/* </div>
                    </Card> */}
        </form>
        <Box sx={{ marginTop: "15px" }}>
          <Grid xs={12} item>
            <CommonButton
              className={styles.search}
              onClick={handleSearch}
              disabled={loading}
              id="serachButton"
            >
              {loading ? (
                <>
                  <ClipLoader color="#fff" loading={loading} size={15} />
                  <span
                    style={{
                      marginLeft: "8px",
                      fontSize: "15px",
                      textAlign: "center",
                    }}
                  >
                    Loading...
                  </span>
                </>
              ) : (
                "Search"
              )}
            </CommonButton>
          </Grid>
        </Box>

        {showDropDown ? (
          <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
            {listItemTable()}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  const renderMainComponent = () => {
    return (
      <>
        <div style={{ display: "flex" }}>
          <div className={styles.DonationAdvisoryContainer}>
            <Typography component="div" className={styles.typoGraphyHeading}>
              Devotee Service
            </Typography>
            <div className={styles.formContainer}>
              <div>
                <Typography component="div" className={styles.typoGraphy}>
                  Matching Donations
                </Typography>
                <div className={styles.cartContainer}>
                  <CommonOutlinedButton
                    onClick={props.onBackClick}
                    sx={{ marginTop: "10px", marginRight: "10px" }}
                  >
                    Back to Search Devotee
                  </CommonOutlinedButton>
                  <div className={styles.text}>Devotee Cart</div>
                  <IconButton aria-label="cart" onClick={handleCart}>
                    <CustomBadge
                      badgeContent={cartItemsList.length}
                      color="secondary"
                    >
                      <img src={cartIcon} alt="cart Icon" />
                    </CustomBadge>
                  </IconButton>
                </div>
              </div>
              <Card className={styles.cardContainer}>
                <div style={{ padding: "24px" }}>
                  <Grid container spacing={2}>
                    <Grid xs={12} sm={3} item >
                      <CustomInputLabel>Name</CustomInputLabel>
                      <CustomTextFeild
                      id="name"
                        fullWidth
                        required
                        onChange={(e) => {
                          handleFieldChange("name", e.target.value);
                          setErrorMessage({ ...errorMessage, name: "" });
                        }}
                        className={
                          errorMessage.name
                            ? styles.errorTextField
                            : styles.textField
                        }
                        value={getDevoteeId()?.fullName?.toUpperCase()}
                      />
                      {errorMessage.name ? (
                        <Typography sx={{ color: "red", fontSize: "12px" }}>
                          {errorMessage.name}
                        </Typography>
                      ) : (
                        ""
                      )}
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                    <Grid xs={12} sm={3} item >
                      {CustomRequiredInputLabel("Purpose of Donation", true)}
                      {PurposeDonationDropdown()}
                    </Grid>
                    {/* <Grid xs={12} sm={3} item>
                      <CustomInputLabel>No. of items</CustomInputLabel>
                      <CustomTextFeild
                        fullWidth
                        required
                        value={formData.noOfItem}
                        onChange={(e) => {
                          handleFieldChange("noOfItem", e.target.value);
                          setErrorMessage({ ...errorMessage, noOfItem: "" });
                        }}
                        className={
                          errorMessage.noOfItem
                            ? styles.errorTextField
                            : styles.textField
                        }
                      />
                      {errorMessage.noOfItem ? (
                        <Typography sx={{ color: "red", fontSize: "12px" }}>
                          {errorMessage.noOfItem}
                        </Typography>
                      ) : (
                        ""
                      )}
                    </Grid> */}
                  </Grid>
                  {isAnadanna && annadanaComponents}
                  {isVastra && vastraComponents}
                  <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                    <Grid xs={12} sm={3} item >
                      {CustomRequiredInputLabel("Amount In Dollars", true)}
                      <CustomTextFeild
                      id="amountInDollars"
                        fullWidth
                        required
                        value={formData.ammountinDollars}
                        onFocus={(e) => {
                          if (e.target.value === "0") {
                            handleFieldChange("ammountinDollars", "");
                          }
                        }}
                        onChange={(e) => {
                          let inputValue = e.target.value;
                          let newErrorMessage = "";

                          if (Number(inputValue) < 1) {
                            newErrorMessage =
                              "Minimum amount is 1";
                          } else {
                            const numericValue = inputValue.replace(
                              /[^0-9.]/g,
                              ""
                            ); // Remove non-numeric characters
                            const truncatedValue = numericValue.slice(0, 10); // Allow only the first 10 numbers
                            inputValue = truncatedValue;
                          }

                          handleFieldChange("ammountinDollars", inputValue);
                          setErrorMessage({
                            ...errorMessage,
                            ammountinDollars: newErrorMessage,
                          });
                        }}
                        className={
                          errorMessage.ammountinDollars
                            ? styles.errorTextField
                            : styles.textField
                        }
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <AttachMoneyIcon fontSize="small" sx={{zIndex:"1", position:"absolute"}} />
                            </InputAdornment>
                          ),
                        }}
                        
                      />
                      {errorMessage.ammountinDollars && (
                        <Typography sx={{ color: "red", fontSize: "12px" }}>
                          {errorMessage.ammountinDollars}
                        </Typography>
                      )}
                    </Grid>

                    <Grid xs={12} sm={3} item >
                      {CustomRequiredInputLabel("Disbursement Reference", true)}
                      <CustomTextFeild
                      id="disbursementReference"
                        fullWidth
                        required
                        value={formData.disbursementReference}
                        onChange={(e) => {
                          handleFieldChange(
                            "disbursementReference",
                            e.target.value
                          );
                          setErrorMessage({
                            ...errorMessage,
                            disbursementReference: "",
                          });
                        }}
                        className={
                          errorMessage.disbursementReference
                            ? styles.errorTextField
                            : styles.textField
                        }
                      />
                      {errorMessage.disbursementReference ? (
                        <Typography sx={{ color: "red", fontSize: "12px" }}>
                          {errorMessage.disbursementReference}
                        </Typography>
                      ) : (
                        ""
                      )}
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                    <Grid xs={12} sm={3} item >
                      {CustomRequiredInputLabel("Period Ending", true)}
                      {BasicDatePicker()}
                    </Grid>
                  </Grid>
                  {isAddMoreFields && membersComponents}
                  {/* {Addmorefields()} */}
                  <Grid xs={12} sm={3} item>
                    {/* {membersList.map((member) => (
                                 <div key={membersList.indexOf(member)}>{member}</div>
                              ))} */}
                  </Grid>
                  <CommonButton
                    sx={{ marginTop: "10px" }}
                    onClick={handleAddMoreFields}
                    id="addMoreMembers"
                  >
                    Add More Members
                  </CommonButton>

                  <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                    <Grid xs={30} sm={13} item >
                      {CustomRequiredInputLabel("Description", true)}
                      <TextareaAutosize
                      id="description"
                        style={{ height: "89px" }}
                        required
                        value={formData.description}
                        onChange={(e) => {
                          handleFieldChange("description", e.target.value);
                          setErrorMessage({ ...errorMessage, description: "" });
                        }}
                        className={
                          errorMessage.description
                            ? styles.errorTextField
                            : styles.textArea
                        }
                      ></TextareaAutosize>
                      {errorMessage.description ? (
                        <Typography sx={{ color: "red", fontSize: "12px" }}>
                          {errorMessage.description}
                        </Typography>
                      ) : (
                        ""
                      )}
                    </Grid>
                  </Grid>
                </div>
              </Card>
              <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                <CommonButton className={styles.addButton} onClick={handleAdd} id="addButton">
                  Add
                </CommonButton>
              </Grid>
            </div>
          </div>
          <Dialog
            open={openCancelDialog}
            onClose={handleCancelDialogClose}
            aria-labelledby="cancel-dialog-title"
            PaperProps={{
              style: {
                height: "calc(100% - 128px)",
                width: "calc(100% - 128px)",
                margin: "64px",
                maxWidth: "804px",
                maxHeight: "600px",
                overflowY: "hidden",
                borderTopLeftRadius: "16px",
                borderTopRightRadius: "16px",
              },
            }}
          >
            {/* {loading ? <ClipLoader /> : null} */}
            <div
              style={{
                backgroundColor: "#882E14",
                width: "auto",
              }}
            >
              <DialogTitle
                sx={{ fontWeight: 700, fontSize: "16px", color: "white" }}
              >
                {"Search Devotee"}
              </DialogTitle>
              <IconButton
                aria-label="close"
                onClick={handleCancelDialogClose}
                sx={{
                  position: "absolute",
                  right: 24,
                  top: 8,
                  color: (theme: any) => theme.palette.grey[500],
                }}
              >
                <CloseIcon sx={{ color: "white" }} />
              </IconButton>
            </div>
            <DialogContent>
              <div>{SearchDevotee()}</div>
            </DialogContent>
          </Dialog>
        </div>
      </>
    );
  };

  return (
    <>
      <Toaster />
      {!showList ? renderMainComponent() : cartComponent()}
    </>
  );
};
export default DonorAdvisoryFunds;
